/**
 * @fileoverview Barrel exports for the character-extractor-full-v2 agent.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, characterExtractorFullV2AgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
